import React from "react";
import HeaderBar from "./header-bar";
// import useLocaleContext from "../../hooks/useLocaleContext";
// import LanguageSwitcher from "../language-switcher";
import UserMenu from "./user-menu";
import HeaderLogo from "./HeaderLogo";
import { Box } from "@material-ui/core";
import Link from "../link";

const Header = () => {
  // const [currentLocale, saveLocale] = useLocaleContext();

  return (
    <HeaderBar data-testid="header">
      <Link to="/">
        <HeaderLogo />
      </Link>
      <Box
        flex={1}
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
      >
        {/* <LanguageSwitcher
          light
          locale={currentLocale}
          onChange={saveLocale}
          locales={[
            { id: "en", label: "English (UK)" },
            { id: "en-GB", label: "Español (ES)" }
            // { id: "es_ES", label: "Spanish (ES)" }
          ]}
        /> */}
        <UserMenu />
      </Box>
    </HeaderBar>
  );
};

export default Header;
